import './Navigation.scss';
import { useState } from 'react';

export default function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  }

  return (
    <header className="header">
      <a href="#home" className="logo">VM</a>
      <ul className={menuOpen ? "nav nav-open" : "nav"}>
        <li className="nav-item">
          <a href="#about" onClick={closeMenu}>About me</a>
        </li>
        <li className="nav-item">
          <a href="#experience" onClick={closeMenu}>Experience</a>
        </li>
        <li className="nav-item">
          <a href="#interests" onClick={closeMenu}>Interests</a>
        </li>
        <li className="nav-item">
          <a href="#contact" onClick={closeMenu}>Contact</a>
        </li>
      </ul>
      <div onClick={toggleMenu} className={menuOpen ? 'menu btn11 open' : 'menu btn11'} >
        <div className="icon-left"></div>
        <div className="icon-right"></div>
      </div>
    </header>
  );
}